import type { Effect, Reducer } from 'umi';

import type { ReplenishmentOrderDataType } from './data';
import { getReplenishmentOrderDetail } from './service';

export interface StateType {
  replenishmentOrder?: ReplenishmentOrderDataType;
}

export interface ModelType {
  namespace: string;
  state: StateType;
  effects: {
    get: Effect;
  };
  reducers: {
    save: Reducer<StateType>;
    clear: Reducer<StateType>;
  };
}

const Model: ModelType = {
  namespace: 'wmsReplenishmentModel',
  state: {
    replenishmentOrder: undefined,
  },
  effects: {
    *get({ payload }, { call, put }) {
      const response = yield call(getReplenishmentOrderDetail, payload);
      yield put({
        type: 'save',
        payload: response.data,
      });
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        replenishmentOrder: action.payload,
      };
    },
    clear() {
      return {
        replenishmentOrder: undefined,
      };
    },
  },
};

export default Model;
